
// reactstrap components
import AddKeyModal from "components/Modals/AddKeyModal";
import AddSocialRecoveryModal from "components/Modals/AddSocialRecoveryModal";
import { useState } from "react";
import { Card, CardBody, CardTitle, Container, Row, Col, Button } from "reactstrap";
import {  Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


const StorageManagerHeader = ({accountData, paths}) => {

  const {storagePaths, publicStoragePaths, privateStoragePaths} = paths


  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row className="justify-content-center mb-4">

              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0" style={{"height":"150px"}}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Items in storage path (/storage)
                         </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{storagePaths?.length}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                          <i className="fas fa-info" />
                        </div>
                      </Col>
                    </Row>
                    
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0" style={{"height":"150px"}}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Items in public storage path (/public)
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{publicStoragePaths?.length}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-orange text-white rounded-circle shadow">
                          <i className="fas fa-info" />
                        </div>
                      </Col>
                    </Row>
                   
                  </CardBody>
                </Card>
              </Col>

              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0" style={{"height":"150px"}}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Items in private storage path (/public)
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{privateStoragePaths?.length}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-red text-white rounded-circle shadow">
                          <i className="fas fa-info" />
                        </div>
                      </Col>
                    </Row>
                   
                  </CardBody>
                </Card>
              </Col>
              
            </Row>


            

           
          </div>
        </Container>
      </div>


    </>
  );
};

export default StorageManagerHeader;
